import AdapterLuxon from '@mui/lab/AdapterLuxon'
import LocalizationProvider from '@mui/lab/LocalizationProvider'
import { ThemeProvider as MuiThemeProvider } from '@mui/material/styles'
import { FC } from 'react'
import { ThemeProvider as ScThemeProvider } from 'styled-components'

import FirebaseProvider from '../../contexts/firebase'
import { IFirebaseConfig, Theme } from '../../redux/configuration'
import { MuiTheme } from '../../styles/mui-theme'

interface IContextProvidersProps {
  firebaseConfig: IFirebaseConfig
  locale: string
  theme: Theme
}

const ContextProviders: FC<IContextProvidersProps> = ({ firebaseConfig, theme, locale, children }) => (
  <FirebaseProvider firebaseConfig={firebaseConfig}>
    <ScThemeProvider theme={theme}>
      <MuiThemeProvider theme={MuiTheme}>
        <LocalizationProvider dateAdapter={AdapterLuxon} locale={locale}>
          {children}
        </LocalizationProvider>
      </MuiThemeProvider>
    </ScThemeProvider>
  </FirebaseProvider>
)

export default ContextProviders
